var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container"},[(_vm.$store.getters.hasPermission('read categories'))?_c('categories-index'):_vm._e(),(_vm.$store.getters.hasPermission('read types'))?_c('types-index'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }